import { Injectable, Inject } from '@angular/core';
// import { Http } from '@angular/http';
// import { AppConfig } from '../app.config';
import { Restangular } from 'ngx-restangular';
//import 'rxjs/add/operator/map';
import { map } from 'rxjs/operators';

@Injectable()
export class DrawService {
  title = 'Kavana Equb Draw';

  constructor(@Inject(Restangular) public Restangular,
  ) {
  }

  public authenticate(auth: any) {
    return this.Restangular.one('oauth/authorize').customPOST(auth);
  }

  public getLoggedInUser() {
    return this.Restangular.one('user').customGET('');
  }

  public getLatestAward(ekub: String) {
    return this.Restangular.one('latestaward/' + ekub).customGET('');
  }

  saveWinner(award: object, id: string) {
    debugger;
    return this.Restangular.one('award/' + id).customPUT(award);
  }

  getEkubMembers(id: String) {
    debugger;
    return this.Restangular.one('ekub/' + id + '/members').customGET('');
  }

}
